



















































import { Component, Vue } from 'vue-property-decorator';
import '@/styles/MCQ.scss';
import { GeneralService } from '../services/general-service';
import config from '../services/api-config';
import router from '../router';
import store from '../store';
import Loader from "../views/Loader.vue";
import BreadCrumb from "./breadCrumb.vue";
import TrainingBreadcrumb from "../components/TrainingBreadcrumb.vue";
import { Traninglist } from '../models/training-types';

@Component({
  components: {
    "loader": Loader,
    BreadCrumb: BreadCrumb,
    TrainingBreadcrumb,
  }
})

export default class TrainingCourses extends Vue {
  private service = new GeneralService();
  private entities: Traninglist[] = [];

  private level_id;
  private admissionformid: any;
  private classid: any;
  public boardId : any;
  public className : any;
  public content : any = '';
  public loading : boolean = false;
  breadcrumbItems: Array<{ text: string; link: any; active?: boolean }> = [];
  data() {
    return {
      breadcrumbItems: [
      ],
    };
  }
  handleClick(event, type) {
    
    const itemText = event.target.innerText;
    // if (itemText === "Chapters") {
    this.updateBreadcrumbs(itemText, type);
    // }
  }
  updateBreadcrumbs(newTopic, type) {

    const exists = this.breadcrumbItems.some(
      item => item.text === newTopic
    );
    if (!exists) {
      this.breadcrumbItems.forEach(item => {
        item.active = false;
      });
      this.breadcrumbItems.push({
        text: newTopic,
        link: '#',
        active: true,
      });

    }
    else {
      // this.reset(type)
      this.breadcrumbItems.pop();

    }

  }


  private isSmart = false;
  private newVideo = false;
  private oldVideo = false;

  public selectSubject(id, name) {

    this.$store.state.selectSubject = id;
    this.$store.state.selectSubjectName = name;
    this.$store.state.certficateurl=this.entities.find(e=>e.id===id)?.certificate;
      router.push('trainingmodules');
    
  }
getProgress(value: number | null | undefined): number {
  return typeof value === 'number' && value >= 0 ? value : 0;
}

  getImageSource(entity: any): string {
    // First priority: use cover image if available
    if (entity.cover && entity.cover.length) {
      return entity.cover;
    }
    // Second priority: try to get icon by name
    return this.getImgUrl(entity.name);
  }

  getImgUrl(pet) {
    if (!pet) {
      return require('@/assets/images/icons/ai.svg');
    }
    
    // Special case for Website Development & Theme Customization
    if (pet === 'Website Development & Theme Customization') {
      try {
        return require('@/assets/images/icons/wb.svg');
      } catch {
        return require('@/assets/images/icons/ai.svg');
      }
    }
    if (pet === 'Python & AI') {
      try {
        return require('@/assets/images/icons/ai.svg');
      } catch {
        return require('@/assets/images/icons/outher.svg');
      }
    }
    if (pet === 'Freelancing Mastery Program') {
      try {
        return require('@/assets/images/icons/fr.svg');
      } catch {
        return require('@/assets/images/icons/outher.svg');
      }
    }
    if (pet === 'Shopify E-Commerce Course') {
      try {
        return require('@/assets/images/icons/shopify.svg');
      } catch {
        return require('@/assets/images/icons/outher.svg');
      }
    }
    if (pet === 'E-Commerce Mastery Program') {
      try {
        return require('@/assets/images/icons/e.svg');
      } catch {
        return require('@/assets/images/icons/outher.svg');
      }
    }
    if (pet === 'Cyber Crime and Law') {
      try {
        return require('@/assets/images/icons/cri.svg');
      } catch {
        return require('@/assets/images/icons/outher.svg');
      }
    }
    
    if (pet[pet.length - 1] == ' ') {
      pet = pet.substring(0, pet.length - 1);
    }
    
    const images = require.context('@/assets/images/icons/', false, /\.svg$/);
    try {
      return images('./' + pet + ".svg");
    } catch {
      return require('@/assets/images/icons/ai.svg');
    }
  }

  handleImgError(event: any) {
    event.target.src = require('@/assets/images/icons/ai.svg');
  }

  mounted() {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    
    this.loading = true;
    this.breadcrumbItems.push({
      text: 'Training Courses',
      link: 'selectEL',
      active: true
    });

  this.service.getTrainingCourses('HADAF')
  .then(result => {

    if (result && Array.isArray(result) && result.length > 0) {
      this.loading = false;
      this.entities = result;

  
    } else {
      this.entities = [];
      this.loading = false;

    }
  })
  
      .catch(err => { 
        this.loading = false;
        console.error(`Error: ${err.message}`); 
      });
  }
}
